import { Injectable } from '@angular/core'
import {
  BaseSite,
  BaseSiteService,
  CURRENCY_CONTEXT_ID,
  isNotNullable,
  JavaRegExpConverter,
  SiteContextConfigInitializer,
  WindowRef,
  Config
} from '@spartacus/core'
import { filter, map, take, tap } from 'rxjs/operators'
import { maxQuantityFallback } from '../../shared/mb-constants'

@Injectable({
  providedIn: 'root'
})
export class MbSiteContextConfigInitializer extends SiteContextConfigInitializer {

  constructor (protected baseSiteService: BaseSiteService,
              protected javaRegExpConverter: JavaRegExpConverter,
              protected winRef: WindowRef,
              protected config: Config) {
    super(baseSiteService, javaRegExpConverter, winRef)
  }

  protected getConfig (site: BaseSite) {
    const siteContextConfig = super.getConfig(site)
    //simple and faster solution for the moment
    let allCountries = ['UN-en']
    const allDeliveryCountries = site.baseStore?.deliveryCountries?.map(country => country?.isocode?.concat('-en') || '') || []
    allCountries = allCountries.concat(allDeliveryCountries)
    return {
      context: {
        ...siteContextConfig.context,
        maxAllowedQuantityPerProductInCart: [site?.maxAllowedQuantityPerProductInCart?.toString() || maxQuantityFallback?.toString()],
        [CURRENCY_CONTEXT_ID]: [site.currency?.isocode || 'USD'],
        countryLanguage: allCountries
      }
    }
  }

  /**
   * Emits the site context config basing on the current base site data.
   *
   * Completes after emitting the value.
   */
  protected resolveConfig () {
    return this.baseSiteService.getAll().pipe(
      map(baseSites => baseSites.find(site => this.isCurrentSite(site)) || baseSites.find(site => site.fallback)),
      tap(baseSite => {
        if (!baseSite) {
          throw new Error(
            `Error: Cannot get base site config! Current url (${this.winRef.location.href})
                doesn't match any of url patterns of any base sites.`
          )
        }
      }),
      filter(isNotNullable),
      map(baseSite => this.getConfig(baseSite)),
      take(1)
    )
  }

  protected isCurrentSite (site: BaseSite) {
    const index = (site.urlPatterns || []).findIndex(javaRegexp => {
      const jsRegexp = this.javaRegExpConverter.toJsRegExp(javaRegexp)
      return jsRegexp && jsRegexp.test(this.winRef.location.href as string)
    })
    return index !== -1
  }
}
